import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import CustomerOverview from '../customer/CustomerOverview'

const styleSheet = theme => ({
  customerResult:{
    float: 'left',
    marginRight: 20,
    maxWidth: 380,
    minWidth: 200,
    [theme.breakpoints.up('xs')]: {
      width: 'calc(100% - 16px)',
    },
    [theme.breakpoints.up('sm')]: {
      width: '380px',
    },
  }
});

class CustomerList extends React.Component {
    render () {
        const theprops = this.props;
        const thecl = theprops.cl;
        const thenodes = thecl.nodes;
        const sterm = this.props.sterm;
        const classes = this.props.classes;

        return (
            <div id="customer-results" style={{clear:'right'}}>
                {thenodes.map(n => {
                    return (
                        <div key={n.accountId} className={classes.customerResult}>
                            <CustomerOverview customer={n} sterm={sterm} history={this.props.history}/>
                        </div>
                    );
                })
                }
                <div style={{clear:'both'}}></div>
            </div>
        );
    }
}

CustomerList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(CustomerList), { cl: graphql`
  fragment CustomerList_cl on CustomerSearchResultsConnection {
    nodes {
      accountId
      accountName
      accountNum
      contactLastName
      contactFirstName
      contactEmail
      contactPhone
      accountStatus
      customerStatus
      floatProblem
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
      soStatus
    }
  }
`});
